"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/tasks/list");
const CrudActions = require("../../actionTypes/tasks/crud");
exports.initialState = {
    status: 'STANDBY',
    layerFilter: 'ALL',
    markings: [],
    tasks: [],
    filteredMarkings: [],
    filteredTasks: [],
    error: undefined
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const markingsLens = monocle.Lens.fromProp('markings');
const tasksLens = monocle.Lens.fromProp('tasks');
const errorLens = monocle.Lens.fromProp('error');
const filteredTasksLens = monocle.Lens.fromProp('filteredTasks');
const filteredMarkingsLens = monocle.Lens.fromProp('filteredMarkings');
const layerFilterLens = monocle.Lens.fromProp('layerFilter');
const methods = {};
exports.methods = methods;
// LIST actions
methods[Actions.SET_LAYER_FILTER] = (state, action) => fp.function.compose((state) => {
    if (action.payload.filter === 'OWN') {
        return filteredTasksLens.set(tasksLens
            .get(state)
            .filter((x) => x.status === 'CREATED' &&
            action.payload.user &&
            action.payload.user.id === x.author.id))(state);
    }
    return filteredTasksLens.set(tasksLens.get(state))(state);
}, (state) => {
    if (action.payload.filter === 'OWN') {
        return filteredMarkingsLens.set(markingsLens
            .get(state)
            .filter((x) => x.status === 'CREATED' &&
            action.payload.user &&
            action.payload.user.id === x.author.id))(state);
    }
    return filteredMarkingsLens.set(markingsLens.get(state))(state);
}, layerFilterLens.set(action.payload.filter))(state);
methods[Actions.FETCH_TASKS_LIST_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
methods[Actions.FETCH_TASKS_LIST_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), tasksLens.set(action.payload.list.filter((x) => x.type === 'TASK')), markingsLens.set(action.payload.list))(state);
methods[Actions.FETCH_TASKS_LIST_FAILED] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload), markingsLens.set([]), tasksLens.set([]))(state);
// CRUD side-effects
methods[CrudActions.CREATE_MARKING_SUCCESS] = (state, action) => {
    return fp.function.compose(statusLens.set('FETCHED'), (state) => {
        const list = markingsLens.get(state);
        return tasksLens.set(list.filter((x) => x.type === 'TASK'))(state);
    }, markingsLens.modify((list) => [...list, action.payload]))(state);
};
//# sourceMappingURL=list.js.map